module.exports = __webpack_public_path__ + "static/media/metrics_increase.894df9d6.svg";